import sitemapJSON from './20231219_sitemap_geo.json' assert { type: 'json' };
import { STATE_NAMES } from './STATES';
import airbnbDataJSON from './AIRBNB_DATA.json' assert { type: 'json' };

type ShortState = keyof typeof STATE_NAMES;
type ZipCode = string; //`${d}${d}${d}${d}${d}`;
type County = string;
type City = string;

type SitemapJSON = {
  [key in ShortState]: {
    [key: County]: {
      [key: City]: ZipCode[];
    };
  };
};

export type StateEntry = { state: ShortState };
export type CountyEntry = { state: ShortState; county: County };
export type CityEntry = { state: ShortState; county: County; city: City };
export type ZipCodeEntry = { state: ShortState; county: County; city: City; zipCode: ZipCode };

export const getAllTopMarketSEOUrls = () => {
  let urls: string[] = [];
  for (let shortState of Object.keys(airbnbDataJSON) as ShortState[]) {
    urls.push(`/top-airbnb-markets/${shortState}`);
  }
  return urls;
};
export const getAllAirbnbSEOUrls = () => {
  const urlSuffixes = ['best-airbnb', 'rates', 'occupancy', 'revenue'];

  let urls: string[] = [];
  for (let shortState of Object.keys(airbnbDataJSON) as ShortState[]) {
    const stateData = airbnbDataJSON[shortState as keyof typeof airbnbDataJSON];

    const cities = (stateData.city as City[]).sort();
    const zipCodes = (stateData.zip_code as ZipCode[]).sort();

    for (let city of cities) {
      urls.push(`/airbnb-market-data/${dasherize(city)}-${shortState}`);

      for (let suffix of urlSuffixes) {
        urls.push(`/airbnb-market-data/${dasherize(city)}-${shortState}/${suffix}`);
      }
    }

    for (let zipCode of zipCodes) {
      urls.push(`/airbnb-market-data/${dasherize(zipCode)}-${shortState}`);

      for (let suffix of urlSuffixes) {
        urls.push(`/airbnb-market-data/${dasherize(zipCode)}-${shortState}/${suffix}`);
      }
    }
  }
  return urls;
};

export const getSomeData = () => {
  const data = sitemapJSON as unknown as SitemapJSON;
  let states: StateEntry[] = [];
  let counties: CountyEntry[] = [];
  let cities: CityEntry[] = [];
  let zipCodes: ZipCodeEntry[] = [];

  let stateLinks: string[] = [];

  for (let state of Object.keys(data) as ShortState[]) {
    const longName = dasherize(STATE_NAMES[state]);

    states = [...states, { state }];
    stateLinks = [...stateLinks, `/sitemap/${longName}`];

    const _counties: County[] = Object.keys(data[state]);
    for (let county of _counties) {
      counties = [...counties, { state, county: county }];

      const _cities: City[] = Object.keys(data[state][county]);
      for (let city of _cities) {
        cities = [...cities, { state, county, city }];

        const _zipCodes = data[state][county][city];
        for (let zipCode of _zipCodes) {
          zipCodes = [...zipCodes, { state, county, city, zipCode }];
        }
      }
    }
  }

  return {
    data,
    states,
    counties,
    cities,
    zipCodes,
    stateLinks,
  };
};

// @ts-ignore
export const dasherize = (s: string = '') => s.replace(/\s/g, '-');
// @ts-ignore
export const undasherize = (s: string = '') => s.replace(/-/g, ' ');
